@if (items().length > 0) {

  @for (item of items(); track item.value) {
    @let selected = selectedValues().includes(item.value);
    <!--  Menu item  -->
    <button bspk-list-item
            data-menu-item
            role="option"
            tabindex="-1"
            [active]="activeIndex() === $index"
            [attr.aria-disabled]="item.disabled || null"
            [attr.aria-posinset]="$index + 1"
            [attr.aria-selected]="selected || null"
            [attr.data-selected]="selected || null"
            [disabled]="item.disabled || null"
            [id]="getItemId(item, $index)"
            [label]="item.label"
            (click)="selectValue(item, !selected)">

      <!--  Trailing checkbox  -->
      @if (isMulti() && showSelectionControl()) {
        <span data-trailing>
          <bspk-checkbox [aria-label]="item.label"
                         [checked]="selected"
                         [disabled]="item.disabled || disabled()"
          />
        </span>
      }
    </button>
  }

} @else {
  <!--  Empty menu  -->
  <div bspk-txt="heading-h5">No results found</div>
  <div bspk-txt="body-base">{{ noResultsMessage() }}</div>
}
